import ApplicationTypes from 'redux/applications/types';

/** ****************************
 * Create application action creators
 ***************************** */

export const startCreateApplication = (application, cb) => ({
  type: ApplicationTypes.START_CREATE_APPLICATION,
  payload: { application, cb },
});

export const createApplicationSuccess = (application) => ({
  type: ApplicationTypes.CREATE_APPLICATION_SUCCESS,
  payload: application,
});

export const createApplicationFailure = (error) => ({
  type: ApplicationTypes.CREATE_APPLICATION_FAILURE,
  payload: error,
});

/** ****************************
 * Edit application action creators
 ***************************** */

export const startEditApplication = (application, cb) => ({
  type: ApplicationTypes.START_EDIT_APPLICATION,
  payload: { application, cb },
});

export const editApplicationSuccess = (application) => ({
  type: ApplicationTypes.EDIT_APPLICATION_SUCCESS,
  payload: application,
});

export const editApplicationFailure = (error) => ({
  type: ApplicationTypes.EDIT_APPLICATION_FAILURE,
  payload: error,
});

/** ***********************************************
 * Fetch Applications
 ************************************************ */

export const startFetchApplications = ({ currentPage, pageSize }) => ({
  type: ApplicationTypes.START_FETCH_APPLICATIONS,
  payload: { currentPage, pageSize },
});

export const fetchApplicationsSuccess = (applications) => ({
  type: ApplicationTypes.FETCH_APPLICATIONS_SUCCESS,
  payload: applications,
});

export const fetchApplicationsFailure = (error) => ({
  type: ApplicationTypes.FETCH_APPLICATIONS_FAILURE,
  payload: error,
});

export const startDeleteApplication = (id) => ({
  type: ApplicationTypes.DELETE_APPLICATION_START,
  payload: id,
});

export const deleteApplicationSuccess = (id) => ({
  type: ApplicationTypes.DELETE_APPLICATION_SUCCESS,
  payload: id,
});

export const addApplicationData = () => ({
  type: ApplicationTypes.ADD_APPLICATION_DATA,
  payload: true,
});

export const openConfirmModal = (id) => ({
  type: ApplicationTypes.OPEN_MODAL,
  payload: id,
});

export const closeConfirmModal = () => ({
  type: ApplicationTypes.CLOSE_MODAL,
});

/** ***********************************************
 * Fetch Courses
 ************************************************ */

export const startFetchCourses = ({ organisation }) => ({
  type: ApplicationTypes.START_FETCH_COURSES,
  payload: { organisation },
});

export const fetchCoursesSuccess = (courses) => ({
  type: ApplicationTypes.FETCH_COURSES_SUCCESS,
  payload: courses,
});

export const fetchCoursesFailure = (error) => ({
  type: ApplicationTypes.FETCH_APPLICATIONS_FAILURE,
  payload: error,
});

/** ***********************************************
 * Search & Filter Apllications
 ************************************************ */

export const searchApplication = (searchPattern, pageSize) => ({
  type: ApplicationTypes.START_APPLICATIONS_SEARCH,
  data: { searchPattern, pageSize },
});
export const filterApplications = ({
  groups,
  published,
  status,
  timeFrame,
  cb,
}) => ({
  type: ApplicationTypes.FILTER_APPLICATIONS,
  data: { groups, published, status, timeFrame, cb },
});
// export const filterByGroups = (groupItemName, organisation, pageSize) => ({
//   type: ApplicationTypes.FILTER_APPLICATIONS_BY_GROUPS,
//   data: { groupItemName, organisation, pageSize },
// });
export const searchResult = (payload) => ({
  type: ApplicationTypes.SEARCH_APPLICATION_SUCCESS,
  payload,
});

/** ***********************************************
 * Fetch single application
 ************************************************ */
export const fetchSingleApplication = (id) => ({
  type: ApplicationTypes.START_FETCH_SINGLE_APPLICATIONS,
  payload: id,
});
export const fetchSingleApplicationSuccess = (payload) => ({
  type: ApplicationTypes.FETCH_SINGLE_APPLICATIONS_SUCCESS,
  payload,
});
export const fetchSingleApplicationFailure = (payload) => ({
  type: ApplicationTypes.FETCH_SINGLE_APPLICATIONS_FAILURE,
  payload,
});

/** ***********************************************
 * Set any data
 ************************************************ */
export const setApplicationStore = (payload) => ({
  type: ApplicationTypes.SET_DATA,
  payload,
});

/** ***********************************************
 * search candidate groups
 ************************************************ */
export const searchCandidateGroup = (name, formId) => ({
  type: ApplicationTypes.SEARCH_CANDIDATE_GROUPS,
  payload: {name, formId},
});
export const searchCandidateGroupSuccess = (payload) => ({
  type: ApplicationTypes.SEARCH_CANDIDATE_GROUPS_SUCCESS,
  payload,
});
export const searchCandidateGroupFailure = (payload) => ({
  type: ApplicationTypes.SEARCH_CANDIDATE_GROUPS_ERROR,
  payload,
});
/** ***********************************************
 * get one candidate group
 ************************************************ */
 export const fetchSingleGroup = (names) => ({
  type: ApplicationTypes.FETCH_SINGLE_GROUP,
  payload: names,
});
export const fetchSingleGroupSuccess = (payload) => ({
  type: ApplicationTypes.FETCH_SINGLE_GROUP_SUCCESS,
  payload,
});
export const fetchSingleGroupFailure = (payload) => ({
  type: ApplicationTypes.FETCH_SINGLE_GROUP_ERROR,
  payload,
});